export const UI_AssetMap = {
  HeroSection: {
    x1: require("../../assets/images/NewImages/HeroSection_1x.png"),
    x2: require("../../assets/images/NewImages/HeroSection_2x.png"),
    x3: require("../../assets/images/NewImages/HeroSection_3x.png"),
  },
  PlayStore_Btn: require("../../assets/images/NewImages/Play_Store.png"),
  AppStore_Btn: require("../../assets/images/NewImages/App_Store.png"),
  ColoringBook_Icon: require("../../assets/images/NewImages/ColoringBook_Icon.jpg"),
  Jigsawhd_Icon: require("../../assets/images/NewImages/Jigsawhd_Icon.jpg"),
  Jigsaw_Icon: require("../../assets/images/NewImages/Jigsaw_Icon.jpg"),
  MathGame_Icon: require("../../assets/images/NewImages/MathGame_Icon.jpg"),
  KidsLearning_Icon: require("../../assets/images/NewImages/KidsLearning_Icon.jpg"),
  BaloonPop_Icon: require("../../assets/images/NewImages/BalloonPop_Icon.jpg"),
  BabyPhone_Icon: require("../../assets/images/NewImages/BabyPhone_Icon.jpg"),
  Background_Img: require("../../assets/images/NewImages/bg.png"),
  Safe_Secure_Img: require("../../assets/images/NewImages/SafeAndSecure.jpg"),
  Education_Fun_Img: require("../../assets/images/NewImages/Education&Fun.jpg"),
  EasyToUse_Img: require("../../assets/images/NewImages/EasyToUse.jpg"),
  BoostCreativity_Img: require("../../assets/images/NewImages/Boost_Creativity.jpg"),
  ParentLove_BG_Img: require("../../assets/images/NewImages/ParentLoves_BlockImg.jpg"),
  Texture_Img: require("../../assets/images/NewImages/Texture_Img.jpg"),
  Bottom_Banner_Img: {
    x1: require("../../assets/images/NewImages/Kids_Bottom_Banner_1x.jpg"),
    x2: require("../../assets/images/NewImages/Kids_Bottom_Banner_2x.jpg"),
    x3: require("../../assets/images/NewImages/Kids_Bottom_Banner_3x.jpg"),
  },
  MathGameBanner_Img: require("../../assets/images/NewImages/MathGameBanner_Img.jpg"),
  KidsLearningBanner_Img: require("../../assets/images/NewImages/KidsLearningBanner_Img.jpg"),
  JigShowPuzzleBanner_Img: require("../../assets/images/NewImages/JigsawPuzzleGameBanner_Img.jpg"),
  JigShowHdPuzzleBanner_Img: require("../../assets/images/NewImages/JigSawHdPuzzleBanner_Img.jpg"),
  BabyPhoneGameBanner_Img: require("../../assets/images/NewImages/BabyPhoneBanner_Img.jpg"),
  BaloonPopGameBanner_Img: require("../../assets/images/NewImages/BaloonPopBanner_Img.jpg"),
  ColoringBooKAppBanner_Img: require("../../assets/images/NewImages/ColoringBookBanner_Img.jpeg"),

  BoyWithLatter_Img: require("../../assets/images/NewImages/BoyWithLatter.png"),
  Envelope_Img: require("../../assets/images/NewImages/MascotWithEnvelop.png"),
};